// セクション(チップバーのジャンプ先)への画面スクロール共通処理。
// 品番マスタ(HinbanMaster)と加工指示(Kakousiji)で共用する。
//
// スクロールは「実際にスクロールしている要素」に対して行う必要がある。
// entry-body コンテナがスクロールしている画面ではコンテナの scrollTop を、
// 親の高さが確定せずウィンドウ側がスクロールしている画面では window を動かす。
// 位置は offsetTop(offsetParent 依存でずれやすい)ではなく
// getBoundingClientRect の相対位置で求める。
export function scrollToPanelElement(containerEl, elem, margin = 50) {
    if (elem === null || elem === undefined) return;
    const canScrollContainer = containerEl !== null && containerEl !== undefined
        && containerEl.scrollHeight > containerEl.clientHeight + 1;
    if (canScrollContainer) {
        const containerRect = containerEl.getBoundingClientRect();
        const elemRect = elem.getBoundingClientRect();
        const top = containerEl.scrollTop + (elemRect.top - containerRect.top) - margin;
        containerEl.scrollTop = top < 0 ? 0 : top;
        return;
    }
    const top = window.pageYOffset + elem.getBoundingClientRect().top - margin;
    window.scrollTo(0, top < 0 ? 0 : top);
}
